import { render, staticRenderFns } from "./AddMarketRuleCommunity.vue?vue&type=template&id=07943e20"
import script from "./AddMarketRuleCommunity.vue?vue&type=script&lang=js"
export * from "./AddMarketRuleCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports